import { ComponentType, lazy } from 'react';

export function isChunkLoadError(error: unknown): boolean {
  return error instanceof Error && /ChunkLoadError|Loading (?:CSS )?chunk|Failed to fetch dynamically imported module/i.test(`${error.name} ${error.message}`);
}

/** A failed webpack download can be requested again without reloading the session. */
export async function importWithRetry<T>(load: () => Promise<T>): Promise<T> {
  try {
    return await load();
  } catch (error) {
    if (!isChunkLoadError(error)) throw error;
    return load();
  }
}

export function lazyWithRetry<T extends ComponentType<any>>(load: () => Promise<{ default: T }>) {
  return lazy(() => importWithRetry(load));
}
